<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>全省党风廉政建设宣教月活动下月举行</h1>
        <h2>
          <span class="mg-16">来源：新华社</span>|
          <span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span>
        </h2>

        <h3>近期，省委办公厅印发活动方案，明确2020年全省党风廉政建设宣传教育月（以下简称“宣教月”）活动于今年8月举行。活动主题为“强化清廉实干担当 聚力决胜全面小康”。</h3>
        <h3>此次“宣教月”活动将聚焦党章党规党纪和国家监察法规，聚焦习近平总书记关于全面从严治党重要论述，聚焦党中央决战脱贫攻坚、决胜全面小康重大决策部署纪律要求，聚焦“集中整治形式主义官僚主义问题2020年行动举措”“鄂纪励十二条”《关于在疫情防控监督中激励保护基层干部积极性的指导意见》等学习贯彻，重点组织开展五项活动，即继续开展党章党规党纪和国家监察法规“学”“讲”“考”活动，精心组织“助力夺取‘双胜利’”主题宣传，分层分类开展“以案五说”（即以案说纪、说法、说德、说害、说责）警示教育活动，扎实推进“廉洁好家风”宣传教育活动，组织开展“优秀廉洁文化作品展播”活动。</h3>
        <h3>方案强调，各级党委（党组）要高度重视“宣教月”活动，自觉担负起活动的主体责任，精心谋划，扎实推进。各地各单位要注重活动实效，聚焦主题，精心组织，集中开展一系列接地气、聚人气的党风廉政建设宣传教育活动。各地各单位要立足本地实际制定活动方案，明确责任分工，加强协调督导，推动各项活动落实落地。各级纪检监察机关要加强监督检查，为活动有效开展提供纪律作风保障。（杨宏斌 夏锐）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/ylkt5-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>